



























import { Component, Watch, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import SelectLostProceduresTable from '@/components/organisms/SelectLostProceduresTable/SelectLostProceduresTable.vue'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  AlertMessage,
  ErrorMessage,
  lendApi,
  LendCollection,
  LendLostRequest,
  LendLostRequestCollection,
  SystemCode
} from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import CODE_KEY from '@/config/code_key'
import {
  LostType,
  ReceiptPrintLostData,
  ReceiptPrintLostDataToJSON,
  ReceiptPrintName
} from '@/types'
import { plainToDateFormat } from '@/utils'
import { CommandType } from '@/types/websocket'

@Component({
  components: {
    ModalFooter,
    SelectLostProceduresTable,
    DataTable
  }
})
export default class ModalLostProcedure extends ComponentVue {
  @Prop({
    type: String,
    required: true
  })
  userId!: string

  @Prop({
    type: String,
    required: true
  })
  userName!: string

  @Prop({
    type: Array,
    required: true
  })
  lendCollections!: LendCollection[]

  dialog: boolean = false

  selectedCode: string = ''

  get items(): SystemCode[] {
    return systemCodeStore.getLendOutCollectionLostExpulsionType.filter(
      (systemCode: SystemCode) => {
        return systemCode.code !== '5' && systemCode.code !== '6'
      }
    )
  }

  get cols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '100',
        items: [
          {
            name: 'name',
            headerText: '内容'
          }
        ]
      }
    ]
  }

  @Watch('dialog')
  initialize(): void {
    if (this.dialog) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.LEND_OUT_COLLECTION_LOST_EXPULSION_TYPE.KEY
      ])

      if (this.items.length > 0) {
        this.selectedCode = this.items[0].code
      }
    }
  }

  open() {
    this.dialog = true
  }

  close() {
    this.dialog = false
  }

  onClickRow(index: number): void {
    this.selectedCode = this.items[index].code
  }

  async lost() {
    const request: LendLostRequest = {
      id: this.userId,
      collections: this.lendCollections.map(
        (item): LendLostRequestCollection => {
          return {
            id: item.id,
            revision: item.revision
          }
        }
      ),
      lostType: this.selectedCode
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await lendApi.lendLost(request)

      // 紛失届レシート出力
      if (this.selectedCode === LostType.LostProcedure) {
        this.lendCollections.forEach(collection => {
          const receiptPrintLostData: ReceiptPrintLostData = {
            branchName: authUserStore.authUser.branchCode.name,
            collectionNo: collection.collectionNo,
            displayTitle: collection.displayTitle,
            lendData: plainToDateFormat(collection.lendTime),
            dueDate: plainToDateFormat(collection.dueDate),
            userId: this.userId,
            userName: this.userName
          }
          this.$webSocket.sendReceiptPrintMessage({
            command: CommandType.ReceiptPrintLost,
            name: ReceiptPrintName.ReceiptPrintLost,
            data: ReceiptPrintLostDataToJSON(receiptPrintLostData),
            subject: `資料番号：${collection.collectionNo}`
          })
        })
      }

      this.$emit('updated')

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('ok')
  onClickOk() {
    this.lost()
  }
}
